import InvoiceBuilderContext from '@nile/client_management/src/Contexts/InvoiceBuilderContext';
import { Checkbox } from '@superops/ui-design-system';
import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  ${({ alignRight }) =>
    alignRight &&
    `
    width: 100%;
    justify-content: flex-end;
  `}
`;

function AuditBulkSelectCell(props) {
  const invoiceContext = useContext(InvoiceBuilderContext);
  const { allAuditItems = [], checkDisabledItem } = props;

  const { records, setRecordsForMultipleSections } = invoiceContext;

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    const itemIdsInPage = allAuditItems
      .filter((item) => !checkDisabledItem({ original: item }))
      .map(({ itemId }) => itemId);
    const selectedAuditRecordIds =
      records?.audit?.map(({ itemId }) => itemId) || [];
    const isAllManuallySelected = itemIdsInPage.reduce(
      (acc, itemId) => acc && selectedAuditRecordIds.includes(itemId),
      true
    );
    if (itemIdsInPage.length) setSelected(isAllManuallySelected);
  }, [records?.audit, allAuditItems]);

  const handleSelection = (checked) => {
    if (checked) {
      const existingSelectedRecords = records?.audit ? [...records.audit] : [];
      const existingRecordIds = existingSelectedRecords.map(
        ({ itemId }) => itemId
      );
      const recordsToAdd = allAuditItems.filter(
        (item) =>
          !existingRecordIds.includes(item.itemId) &&
          !checkDisabledItem({ original: item })
      );
      setRecordsForMultipleSections({
        audit: [...existingSelectedRecords, ...recordsToAdd]
      });
    } else {
      const allAuditIds = allAuditItems.map(({ itemId }) => itemId);
      const newAuditRecords = records?.audit
        ? records.audit.filter(({ itemId }) => !allAuditIds.includes(itemId))
        : [];
      setRecordsForMultipleSections({
        audit: [...newAuditRecords]
      });
    }
  };

  return (
    <Wrap className="cell">
      <Checkbox
        disabled={
          !allAuditItems?.length ||
          allAuditItems?.reduce(
            (acc, item) => acc && checkDisabledItem({ original: item }),
            true
          )
        }
        checked={selected}
        onChange={(checked) => {
          handleSelection(checked);
          setSelected(checked);
        }}
        name="item-selection"
      />
    </Wrap>
  );
}

export default AuditBulkSelectCell;
